import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../commonComponents/translate';
import SubmitButton from './SubmitButton';

function SingleChoice({ t, questionId, options, onSubmit, value }) {
  const [selectedAnswer, setSelectedAnswer] = useState(
    value ? value.answer : null,
  );
  useEffect(() => setSelectedAnswer(value ? value.answer : null), [questionId]);

  const handleSubmit = () => onSubmit({ answer: selectedAnswer });

  const answerButtonClass = answerId =>
    cx('quiz-answer-list-item', { selected: answerId === selectedAnswer });

  return (
    <div className="m-portlet__body quiz-answers-container">
      <h4>{t('survey_choice_option_hint')}</h4>
      <div className="quiz-answer-list">
        {options.map(option => (
          <button
            key={option._id}
            type="button"
            className={answerButtonClass(option._id)}
            onClick={() => setSelectedAnswer(option._id)}
          >
            {option.option}
          </button>
        ))}
      </div>
      <SubmitButton
        onSubmit={handleSubmit}
        text={t('survey_pickAnswer')}
        disabled={!selectedAnswer}
      />
    </div>
  );
}

SingleChoice.propTypes = {
  t: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      option: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.shape({ answer: PropTypes.string.isRequired }),
};

SingleChoice.defaultProps = {
  value: null,
};

export default translate(SingleChoice);
